//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import html2canvas from 'html2canvas';

export default {
  components: {
  },
  props: ['scale', 'type'],
  name: 'FrhomoloImageSynthesis',
  data() {
    return {
      base64Img: '',
      ifdown: false,
      blob: null,
      callback: null,
      imageType: 'image/png',
      showHideOnBlur: false
    }
  },
  methods: {
    getImage() {
      const el = document.querySelector('.frhomolo-image-synthesis');
      const canvas = document.createElement('canvas');
      const scale = +this.scale || 2;
      const type = this.imageType || 'image/png'
      html2canvas(el, {
        useCORS: true,
        scale: scale,
        logging: true,
        y: el.getBoundingClientRect().top + window.pageYOffset, // 页面在垂直方向的滚动距离
      }).then(mycanvas => {
        this.base64Img = mycanvas.toDataURL(type, 1.0);
        this.toBlob(mycanvas);
      });
    },
    toBlob(mycanvas) {
      if (!HTMLCanvasElement.prototype.toBlob) {
        Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
          value: function (callback, type, quality) {
            let canvas = this;
            setTimeout(function () {
              let binStr = atob(canvas.toDataURL(type, quality).split(',')[1]);
              let len = binStr.length;
              let arr = new Uint8Array(len);
              for (let i = 0; i < len; i++) {
                arr[i] = binStr.charCodeAt(i);
              }
              callback(new Blob([arr], { type: type }));
            });
          }
        });
      }
      let type = this.imageType || 'image/png';
      mycanvas.toBlob((blob) => {
        if (this.ifdown) {
          this.showHideOnBlur = true;
        }
        this.blob = blob;
        if (this.callback) {
          this.callback(this.blob, this.base64Img);
        }
      }, type);
    },
    getRes(ifdown, callback) {
      if (ifdown) {
        this.ifdown = ifdown;
      } else {
        this.ifdown = false;
      }
      this.blob = null;
      let that = this;
      if (callback) {
        this.callback = callback;
      }
      that.getImage();
    }
  },
  watch: {
    type() {
      if (this.type) {
        if (this.type === 'png' || this.type === 'jpg' || this.type === 'jpeg' || this.type === 'webp') {
          this.imageType = 'image/' + this.type;
        } else if (this.type.startsWith('image/')){
          this.imageType = this.type;
        }
      }
    }
  },
  computed: {},
  created() {
  },
  mounted() {
  }
};
